import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslate } from 'react-admin';

interface AccountLockedModalProps {
  open: boolean;
  onClose: () => void;
}

const AccountLockedModal = ({ open, onClose }: AccountLockedModalProps) => {
  const translate = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="account-locked-dialog-title"
    >
      <DialogTitle
        id="account-locked-dialog-title"
        sx={{
          bgcolor: 'error.main',
          color: 'error.contrastText',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <LockIcon />
        {translate('notification.account_locked_modal.title')}
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', mt: 2 }}>
        <Typography paragraph>
          {translate('notification.account_locked_modal.message')}
        </Typography>
        <Typography>
          <Link
            href="https://support-itmlimited.atlassian.net/servicedesk/customer/portals"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate('notification.account_locked_modal.help_center_link')}
          </Link>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={onClose}>
          {translate('notification.account_locked_modal.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountLockedModal;

